import prepareDocumentsForSignDictionary from '@features/registration/shared/ui/prepare-documents-for-sign/i18n/ru/prepare-documents-for-sign.dic.json';

export const prepareDocumentsForSign = {
  REGISTRATION_PREPARE_DOCUMENTS_FOR_SIGN: prepareDocumentsForSignDictionary,
};

export const prepareDocumentForSignNamespaces = Object.keys(
  prepareDocumentsForSign
);
